var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgServices(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M12.4652 17H5.53477C3.51692 17 1.875 15.3733 1.875 13.3734V9.37658C1.875 7.37671 3.51692 5.75 5.53477 5.75H12.4652C14.4831 5.75 16.125 7.37671 16.125 9.37658V13.3734C16.125 15.3733 14.4831 17 12.4652 17Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8163 8C11.508 8 11.2577 7.75725 11.2577 7.45816V5.26767C11.2577 4.06334 10.2477 3.08368 9.0067 3.08368C8.43539 3.08368 7.83577 3.3062 7.40896 3.71583C6.98141 4.12691 6.74454 4.67381 6.7423 5.25756V7.45816C6.7423 7.75725 6.49203 8 6.18365 8C5.87528 8 5.625 7.75725 5.625 7.45816V5.26767C5.62872 4.37977 5.98328 3.56051 6.62238 2.94714C7.26073 2.33233 8.08605 2.02384 9.00894 2C10.8637 2 12.375 3.46586 12.375 5.26767V7.45816C12.375 7.75725 12.1247 8 11.8163 8Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgServices);
export default __webpack_public_path__ + "static/media/services.3ee8625bf7af84b8639d3e73a316ceb3.svg";
export { ForwardRef as ReactComponent };